import { Modal } from 'almanac-ui/Modal'

import { Button } from 'blaze-ui/Button'
import Styles from './IntegrationInitializationModal.module.scss'
import { ArrowUpRightSquareContained } from 'blaze-ui/icons'
import { Heading } from 'blaze-ui/Heading/Heading'
import { IntegrationInitializationContent } from './IntegrationInitializationContent'
import { IntegrationInitializationComponentProps } from './types'
import { IntegrationHelpButton } from 'components/IntegrationHelpButton/IntegrationHelpButton'

export const ModalTitle = ({ icon, title }: { icon: React.ReactNode; title: string }) => {
  return (
    <div className={Styles.modalTitle}>
      {icon}
      <Heading level={3}>{title}</Heading>
    </div>
  )
}

export const IntegrationInitializationModal = ({
  onClose,
  onConfirm,
  notice,
  primaryButtonText,
  title,
  icon,
  providerName,
  onPressOutside,
}: IntegrationInitializationComponentProps) => {
  return (
    <Modal.Root size="sm" blaze onPressOutside={onPressOutside} aria-label={`Connect to ${providerName}`}>
      <Modal.Header
        title={<ModalTitle icon={icon} title={title} />}
      />
      <IntegrationInitializationContent notice={notice} providerName={providerName} />
      <Modal.Footer>
        <Modal.FooterContent slot="left">
          <Button variant="tertiary" onPress={onClose}>
            Back
          </Button>
        </Modal.FooterContent>
        <Modal.FooterContent slot="right">
          <div className={Styles.helpButtonContainer}>
            <IntegrationHelpButton size="sm" integration={providerName} />
          </div>
          <Button onPress={onConfirm} endIcon={ArrowUpRightSquareContained} aria-label={primaryButtonText}>
            {primaryButtonText}
          </Button>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
}
